module.exports = __webpack_public_path__ + "img/header_logo_outflink.5282c6e7.png";